import React from 'react';
import { Header } from '@sky-tv-group/components';
import { NavigationLinks } from '@sky-tv-group/shared';

export function HeaderPage(links: NavigationLinks) {
  return <Header links={links} />;
}
